import { notEmpty, type Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { useLazyLayerMetaModel } from '../../../context/useLazyLayerMetaModel'
import { MetaTypes, type ModelMetaType } from '../../../types/metaModel'

export const useTemplatedModelTypes = (layerId: Optional<string>) => {
  const metaModel = useLazyLayerMetaModel(layerId)

  return useMemo(() => {
    const templates = Array.from(metaModel.types.values() ?? [])
      .filter(
        (t): t is ModelMetaType =>
          t._type === MetaTypes.ModelMetaType &&
          !!t.modelType?.stereoTypes.includes('Templated'),
      )
      .map((t) => t.modelTypeName)
      .filter(notEmpty)

    const libraries = Array.from(metaModel?.types?.values() ?? [])
      .filter(
        (t): t is ModelMetaType =>
          t._type === MetaTypes.ModelMetaType &&
          (!!t.typeName.endsWith('Library') ||
            !!t.stereoTypes.includes('IsLibrary')) &&
          !!t.configurationDetails,
      )
      .map((t) => t.typeName)

    return templates.concat(libraries)
  }, [metaModel.types])
}
